export const SEARCH_INPUT_MAX_LENGTH = 255;
